import * as React from 'react';
import {FlatList, StyleSheet, Text, View, Dimensions } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';
import Header from '../components/Header';
import TrendingButton from '../components/TrendingButton';
import { Colors, Fonts } from '../utils/Constants';
import ReactGA from 'react-ga';

export default class BrowseCampaigns extends React.PureComponent{
  constructor(props){
    super(props);
    this.state= {
      width: Dimensions.get('window').width,
      height: Dimensions.get('window').height,
      campaigns: []
    }
    Dimensions.addEventListener("change", this.handler);
    this.retrieveAllCampaigns();
    ReactGA.pageview('/browse');
  }

  handler = (dims) => {
    this.setState({
      width: dims.window.width,
      height: dims.window.height,
    });
  }

  componentWillUnmount() {
    // Important to stop updating state after unmount
    Dimensions.removeEventListener("change", this.handler);
  }

  retrieveAllCampaigns = () => {
    fetch('https://fddpufj248.execute-api.us-east-1.amazonaws.com/dev/user/retrieveAllCampaigns')
    .then(response => response.json())
    .then(data => {
      this.setState({campaigns: data});
    });
  }

  render(){
    let widthCutoff = 1207;
    let styling = {};
    let screenWidth = this.state.width >=1207 ? 1067 : this.state.width;
    if (this.state.width >=widthCutoff){
      styling.width = this.state.width >= 1207 ? 1067 : '75%',
      styling.layout = 'row';
      styling.screenWidth = '100%';
      styling.infoView = {flex: 1, paddingRight: '5%', width: '90%'};
      styling.image = {
        flex: 1,
        height: 400,
        resizeMode: 'contain'
      };
    } else {
      styling.width = this.state.width >= 1067 ? 1067 : '90%';
      styling.layout = 'column';
      styling.screenWidth = '90%';
      styling.infoView = {width: '100%'};
      styling.image = {
        marginTop: '5%',
        height: this.state.width >=650 ? 400 : this.state.width * 0.6,
        width: '80%',
        resizeMode: 'contain'
      };
    }
    //dimension ratio is 1 (width) by 0.75 (height)
    let cardSize = {width: screenWidth*0.40, height: screenWidth*0.3, numColumns: 2}
    if (screenWidth <= 800 && screenWidth >= 500) {
      cardSize = {width: screenWidth*0.8, height: screenWidth*0.6, numColumns: 1}
    } else if (this.state.width < 500) {
      cardSize = {width: screenWidth*0.9, height: screenWidth*0.68, numColumns: 1}
    }

    return (
        <ScrollView contentContainerStyle={styles.contentContainer}>
          <View style={{width: screenWidth, alignItems: 'center', paddingTop: 10}}>
          <Header color={'black'} navigation={this.props.navigation} width = {styling.width} screenWidth={this.state.width}/>
            <Text style={[styles.topBlurbText, {fontSize: screenWidth >=500 ? 30 : 20}]}>
              Browse Campaigns
            </Text>
            <FlatList
              style={{marginBottom: 40}}
              data={this.state.campaigns}
              key={cardSize.numColumns}
              numColumns={cardSize.numColumns}
              renderItem={({ item }) => (
                <TrendingButton
                  source={item.header_image}
                  title={item.title}
                  description={item.description}
                  supporters={item.supporters}
                  tags={item.tags}
                  width={cardSize.width}
                  height={cardSize.height}
                  navigate={() => this.props.navigation.push('Campaign', {id: item.unique_id})}
                />
              )}
            />
          </View>
        </ScrollView>
    );
  }
}

BrowseCampaigns.navigationOptions = {
  header: null,
};


const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
  contentContainer: {
    alignItems: 'center',
    flexGrow: 1,
    backgroundColor: '#fff',
    // flex: 1
  },
  welcomeContainer: {
    alignItems: 'center',
    flex: 1,
    marginTop: 10,
    marginBottom: 20,
  },
  header :{
    flexDirection: 'row',
    alignItems: 'center',
    height: 60,
    width: '100%',
    justifyContent: 'center'
  },
  topBlurbText: {
    fontFamily: Fonts.mainFont,
    fontWeight: 'bold',
    alignSelf: 'flex-start',
    paddingLeft: '8%',
    marginTop: 40,
    marginBottom: 15
  },
  lowerBlurbText: {
    fontFamily: Fonts.mainFont,
    fontSize: 20,
    paddingTop: 20
  },
  landingImage: {
    flex: 1,
    height: 400,
    resizeMode: 'fit'
  }
});
